import { Router } from '@angular/router';
import { LocalStorageService } from './local-storage-service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, map, Observable, of, tap } from 'rxjs';
import { UserService } from './user.service';
import { StorageEnum } from '../core/enums/StorageEnum';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  //declaracion de la url de la API
  private baseUrl: string = environment.StaffLogin;

  constructor(
    private http: HttpClient,
    private UserService:UserService,
    private LocalStorageService:LocalStorageService,
    private Router:Router
  ) { }

  login(login: FormData):Observable<any>{
    return this.http.post<any>(`${this.baseUrl}authentication/login/`, login);
  }

  logout(){
    this.LocalStorageService.clear();
    this.Router.navigateByUrl("/login")
  }
 //Metodo validar token
 validarToken(): Observable<boolean> {

    const token = localStorage.getItem(StorageEnum.TOKEN);

    if(!token){
      return of(false);
    }

    this.UserService.User = this.LocalStorageService.get(StorageEnum.USER)!;

    return of(true);
  }


}
